import { defineSseEvent } from '@terra/shared-sse-contracts';
import {
  type TargetTypeType,
  TargetTypeSchema,
} from '@terra/shared-schemas-orchestrator';
import { z } from 'zod';

export const SignalSseEventTypeEnum = {
  SIGNAL_ASSIGNED: 'signal.assigned',
  SIGNAL_UNASSIGNED: 'signal.unassigned',
  SIGNAL_UPDATED: 'signal.updated',
  SIGNAL_CREATED: 'signal.created',
} as const;

export type SignalSseEventType =
  (typeof SignalSseEventTypeEnum)[keyof typeof SignalSseEventTypeEnum];

export type SignalAssignmentEventPayload = {
  signalId: string;
  targetId: string;
  targetType: TargetTypeType;
  assigneeId?: string;
  assigneeName?: string;
};

export type SignalUpdateEventPayload = {
  signalId: string;
  targetId: string;
  updates: Record<string, unknown>;
};

export type SignalCreatedEventPayload = {
  signalId: string;
  targetId: string;
  targetType: TargetTypeType;
  category: string;
  description: string;
  stage: string;
  status: string | null;
};

export const SignalAssignmentEventPayloadSchema = z.object({
  signalId: z.string(),
  targetId: z.string(),
  targetType: TargetTypeSchema,
  assigneeId: z.string().optional(),
  assigneeName: z.string().optional(),
});

export const SignalCreatedEventPayloadSchema = z.object({
  signalId: z.string(),
  targetId: z.string(),
  targetType: TargetTypeSchema,
  category: z.string(),
  description: z.string(),
  stage: z.string(),
  status: z.string().nullable(),
});

export const SIGNAL_ASSIGNED_SSE_EVENT = defineSseEvent({
  type: SignalSseEventTypeEnum.SIGNAL_ASSIGNED,
  payload: SignalAssignmentEventPayloadSchema,
  channelPrefix: 'signal-assignment',
  channelKey: ({ signalId }) => signalId,
  target: {
    type: ({ targetType }) => targetType,
    id: ({ targetId }) => targetId,
  },
});

export const SIGNAL_UNASSIGNED_SSE_EVENT = defineSseEvent({
  type: SignalSseEventTypeEnum.SIGNAL_UNASSIGNED,
  payload: SignalAssignmentEventPayloadSchema,
  channelPrefix: 'signal-assignment',
  channelKey: ({ signalId }) => signalId,
  target: {
    type: ({ targetType }) => targetType,
    id: ({ targetId }) => targetId,
  },
});

export const SIGNAL_CREATED_SSE_EVENT = defineSseEvent({
  type: SignalSseEventTypeEnum.SIGNAL_CREATED,
  payload: SignalCreatedEventPayloadSchema,
  channelPrefix: 'signal-created',
  channelKey: ({ signalId }) => signalId,
  target: {
    type: ({ targetType }) => targetType,
    id: ({ targetId }) => targetId,
  },
});
